import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import CustomDropdownWithButtonAndPrompt from 'components/base/CustomDropdownWithButtonAndPrompt';
import { PermissionCodes } from 'config/PermissionCodes';
import { COUPON_TYPES } from 'config/CustomEnums';

function CouponDropdownWithButtonAndPrompt({
  title,
  valueFieldName,
  placeholder,
  dropDownSearchBarPlaceholder,
  customOnChange=()=> {},
  focusChange = () => { },
  focusKey,
  description,
  bottomTips,
  hasAddButton = false,
  addButtonInfo,
  promptConfig,
  noTopSpace = true,
  formErrorId = valueFieldName,
  defaultFilter: customDefaultFilter,
}) {
  const defaultFilter = {
    type: [COUPON_TYPES.NORMAL],
    ...customDefaultFilter
  }
  const { watch, formState: { errors }, setValue } = useFormContext();
  const watchCoupon = watch(valueFieldName)
  const defaultValue = {
    value: watchCoupon,
    label: watchCoupon?.pk
      ? `[ID: ${watchCoupon?.pk}] ${watchCoupon?.name}`
      : watchCoupon?.name,
  }

  const { couponTemplateList } = useSelector((state) => ({
    couponTemplateList: state.couponList?.couponTemplateList,
  }));

  const defaultAddButtonInfo = {
    requires: PermissionCodes.addCouponTemplate,
    title: 'Create Now',
    customClass: 'multiple-select-option-add btn-add-button-common',
  }

  const onSelectChange = (value) => {
    if (valueFieldName) {
      setValue(valueFieldName, value?.value || {}, { shouldDirty: true })
    }
    customOnChange(value?.value);
  };

  const onFocus = () => {
    focusKey && focusChange(focusKey)
  }
  return (
    <CustomDropdownWithButtonAndPrompt
      title={title}
      description={description}
      placeholder={placeholder}
      dropDownSearchBarPlaceholder={dropDownSearchBarPlaceholder}
      bottomTips={bottomTips}
      titleStyle={noTopSpace ? 'create-section-label-no-top-space' : ''}
      defaultValue={defaultValue}
      setValue={onSelectChange}
      source={couponTemplateList}
      hasAddButton={hasAddButton}
      addButtonInfo={hasAddButton ? { ...defaultAddButtonInfo, ...addButtonInfo } : {}}
      onFocus={onFocus}
      labelContainPk={true}
      errors={errors}
      formErrorId={formErrorId}
      promptConfig={promptConfig}
      loadMoreAction={'couponList/getCurrentPageTemplateList'}
      filterAction={'couponList/getCurrentPageTemplateList'}
      defaultFilter={defaultFilter}
    />
  );
}

export default CouponDropdownWithButtonAndPrompt;
